import React, { useEffect } from 'react';
import { makeStyles, Theme, createStyles, } from '@material-ui/core';
import { SpriteDefine, RenderImage } from './SpriteManager';


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        position: "relative",
        backgroundColor: "#aaa",
    },
    media: {
        width: "25%", // 100%
        height: "25%", // 100%
        verticalAlign: "bottom",
    },
    hidden: {
        width: "100%", // 100%
        height: "100%", // 100%
        verticalAlign: "bottom",
        visibility: "hidden"
    },
    absolute: {
        width: "100%", // 100%
        height: "100%", // 100%
        verticalAlign: "bottom",
        position: "absolute"
    }
  }),
);


interface Props {
    sprite?: SpriteDefine,
    character?: {
        shirt: string,
        jacket: string,
        hair: string,
        eye: string,
        mouth: string,
        accessory: string,
        background: string,
        bodyColor: string,
        hairColor: string,
        eyeColor: string,
        backgroundColor: string,
    },
    afk?: boolean
    absence?: boolean
    suspended?: boolean
    width?: number
    height?: number
}

function Character(props: Props) {

    const classes = useStyles()

    const [canvasSize] = React.useState({width: props.width || 384, height: props.height || 384})

    let background: HTMLCanvasElement | null = null
    let canvas: HTMLCanvasElement | null = null
    let mask: HTMLCanvasElement | null = null

    const mixImage = (input: {ctx: CanvasRenderingContext2D, ctxMask: CanvasRenderingContext2D, mask: HTMLCanvasElement, img: RenderImage, color: string, size: {width: number, height: number}, maskMixMode?: string | undefined}) => {
        if (input.ctx && input.ctxMask && input.img.img) {
            // mask
            input.ctxMask.globalCompositeOperation = "destination-over"
            input.ctxMask.drawImage(input.img.img, input.img.x,input.img.y,input.img.w,input.img.h, 0,0,input.size.height,input.size.height)
            // img
            input.ctx.globalCompositeOperation = "destination-over"
            input.ctx.fillStyle = input.color
            input.ctx.fillRect(0, 0, input.size.width, input.size.height)
            input.ctx.globalCompositeOperation =  "destination-in"
            input.ctx.drawImage(input.mask, 0,0)
        }
    }

    const drawImage = (input: {ctx: CanvasRenderingContext2D, img: RenderImage, size: {width: number, height: number}, mixMode?: string | undefined}) => {
        if (input.ctx && input.img.img) {
            // img
            input.ctx.globalCompositeOperation = input.mixMode || "source-over"
            input.ctx.drawImage(input.img.img, input.img.x,input.img.y,input.img.w,input.img.h, 0,0,input.size.height,input.size.height)
        }
    }

    useEffect(()=>{
        console.log("background Effect")
        if (background && props && props.sprite && props.character) {
            const ctx = background.getContext("2d")
            const table  = props.sprite.table["0"]
            const bg = props.sprite.background[props.character.background]

            if (ctx && bg?.img && table?.img) {

                console.log("background ctx")
                // gray out
                if (props.absence) {
                    ctx.fillStyle = "#888888"
                } else {
                    ctx.fillStyle = props.character.backgroundColor
                }

                ctx.globalCompositeOperation = "source-over"
                ctx.fillRect(0, 0, canvasSize.width, canvasSize.height)
                drawImage({ctx:ctx,img:bg,size:canvasSize,mixMode:"screen"})

                drawImage({ctx:ctx,img:table,size:canvasSize,mixMode:"source-over"})
            }
        }

    },[props, canvasSize, props.sprite, props?.absence, props?.character?.background, props?.character?.backgroundColor, background])


    useEffect(()=>{
        console.log("canvasEffect")
        if (canvas && mask && props && props.sprite && props.character && !props.suspended) {
            console.log("ready!")
            const ctx = canvas.getContext("2d")
            const ctxMask = mask.getContext("2d")
            const body  = props.sprite.body[props.character.bodyColor]
            const shirt = props.sprite.shirt[props.character.shirt]
            const jacket = props.sprite.jacket[props.character.jacket]
            const hair  = props.sprite.hair[props.character.hair]
            const eye   = props.sprite.eye[props.character.eye]
            const mouth = props.sprite.mouth[props.character.mouth]
            const accessory = props.sprite.accessory[props.character.accessory]
            const hairHL = hair?.highlight ? props.sprite?.highlight?.[hair.highlight] : undefined
            const eyeHL  = eye?.highlight ? props.sprite?.highlight?.[eye.highlight] : undefined
            const pc    = props.sprite.pc["0"]

            console.log([ctx, ctxMask, 
                body?.head?.img, body?.body?.img, body?.leftArm?.img, body?.rightArm?.img,
                shirt?.body?.img, shirt?.leftArm?.img, shirt?.rightArm?.img,
                jacket?.body?.img, jacket?.leftArm?.img, jacket?.rightArm?.img,
                hair?.img , eye?.img , mouth?.img, accessory?.img && pc?.img])

            if (ctx && ctxMask && 
                body?.head?.img && body?.body?.img && body?.leftArm?.img && body?.rightArm?.img &&
                hair?.img && eye?.img && mouth?.img) {
                console.log("ctx")

                const start = new Date()
                
                // clear
                ctx.globalCompositeOperation = "source-over"
                ctx.clearRect(0, 0, canvasSize.width, canvasSize.height)
                ctxMask.clearRect(0, 0, canvasSize.width, canvasSize.height)
                
                const mixProp = {
                    ctx: ctx,
                    ctxMask: ctxMask,
                    mask: mask,
                    size: canvasSize
                }

                if (!props.afk) {
                    
                    // hair
                    mixImage({...mixProp, img:hair, color:props.character.hairColor})
                    
                    // eye
                    mixImage({...mixProp, img:eye, color:props.character.eyeColor})

                    // mix mask
                    ctx.globalCompositeOperation = "multiply"
                    ctx.drawImage(mask, 0,0)

                    // highlight
                    eyeHL && drawImage({...mixProp, img:eyeHL, mixMode: "source-over"})
                    hairHL && drawImage({...mixProp, img:hairHL, mixMode: "source-over"})
                    
                    // body
                    drawImage({...mixProp, img:body.rightArm, mixMode: "source-over"})
                    drawImage({...mixProp, img:shirt.rightArm, mixMode: "source-over"})
                    drawImage({...mixProp, img:jacket.rightArm, mixMode: "source-over"})
                    
                    drawImage({...mixProp, img:body.body, mixMode: "source-over"})
                    drawImage({...mixProp, img:shirt.body, mixMode: "source-over"})
                    drawImage({...mixProp, img:jacket.body, mixMode: "source-over"})

                    drawImage({...mixProp, img:body.leftArm, mixMode: "source-over"})
                    drawImage({...mixProp, img:shirt.leftArm, mixMode: "source-over"})
                    drawImage({...mixProp, img:jacket.leftArm, mixMode: "source-over"})

                    // mouth
                    drawImage({...mixProp, img:mouth, mixMode: "source-over"})
                    
                    // head
                    drawImage({...mixProp, img:body.head, mixMode: "destination-over"})

                    // pc
                    drawImage({...mixProp, img:pc, mixMode: "source-over"})
                    
               }

                drawImage({...mixProp, img:accessory, mixMode: "source-over"})
                    
                const end = new Date()
                console.log(`Canvas render ms : ${end.getTime() - start.getTime()}`)

                
            }
        }
    }, [canvas, mask, canvasSize, props,
        props.sprite, props?.character?.shirt, props?.character?.jacket, 
        props?.character?.hair, props?.character?.eye, props?.character?.mouth, 
        props?.character?.accessory, 
        props?.character?.bodyColor, props?.character?.hairColor, props?.character?.eyeColor, 
        canvasSize.height, canvasSize.width, props.suspended])
    
    return (
        <div className={classes.root} >
            <canvas 
                height={canvasSize.height}
                width={canvasSize.width}
                className={classes.absolute}
                ref={e=>background = e}
                ></canvas>
            <canvas 
                height={canvasSize.height}
                width={canvasSize.width}
                className={classes.absolute}
                ref={e=>canvas = e}
            ></canvas>
            <canvas 
                height={canvasSize.height}
                width={canvasSize.width}
                className={classes.hidden}
                ref={e=>mask = e}
            ></canvas>
        </div>
    )
}

export default Character;